import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import styled from "styled-components";

import Dropdown from "components/atoms/Dropdown";
import Icon from "components/atoms/Icon";
import Tooltip from "components/atoms/Tooltip";
import Button from "components/atoms/button/Button";
import { BUTTON_STYLES } from "components/atoms/button/presets";
import Text from "components/atoms/text/Text";

const Container = styled.div`
    width: 100%;
`;

const TagItemWrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: auto;
    max-width: 180px;
    min-height: 20px;
`;

const TagItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: ${(props) => props.$margin || "2px"};
    padding: 2px 4px;
    max-width: 180px;
    height: 20px;
    outline: none;
    background-color: var(--color-Tag);
    border: transparent;
    border-radius: 2px;
    cursor: pointer;
    transition: all 120ms ease-in;

    &:hover {
        background-color: var(--color-TagActive);
    }
`;

const MoreTag = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 2px 4px;
    max-width: 180px;
    height: 20px;
    outline: none;
    background-color: var(--color-TagActive);
    border: transparent;
    border-radius: 2px;
    cursor: pointer;
`;

const BlankBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    background-color: var(--color-BaseBlue);
    border-radius: 2px;
`;

const BlankText = styled(Text)`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

const MoreBox = styled.div`
    width: 240px;
    max-width: 240px;
    min-height: 80px;
    background-color: var(--color-White);
    border: solid 1px var(--color-Outline);
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 1;
`;

const MoreBoxHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    width: 100%;
    height: 32px;
    border-bottom: solid 1px var(--color-Outline);
`;

const MoreContentWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 8px 8px 8px 8px;
    max-width: 240px;
    max-height: 160px;
    overflow-x: hidden;
    overflow-y: auto;
`;

const TagListTitle = styled(Text).attrs({
    variant: "body-md-500",
    color: "var(--color-SubBlack)",
})``;

const TagListText = styled(Text).attrs({
    variant: "body-sm-400",
    color: "var(--color-SubBlack)",
    ellipsis: true,
})``;

function ReferenceTagList(props) {
    const nav = useNavigate();
    const { space_uuid } = useParams();

    const [showTagBox, setShowTagBox] = useState(false);

    const selectedTags = props.selectedTagIds || [];

    const handleNavigate = (state) => {
        sessionStorage.setItem("activeTab", "Tags");
        if (props.onNavigate) {
            props.onNavigate(state);
            return;
        }
        nav(`/${space_uuid}/reference`, { state });
    };

    return (
        <Container>
            {props.reference?.tag_mappings?.length > 0 ? (
                <TagItemWrap>
                    <Tooltip message={"필터 적용"}>
                        <TagItem
                            $margin={"0 4px 0 0"}
                            style={
                                props.reference.tag_mappings.length > 1 ? { maxWidth: "140px" } : { maxWidth: "180px" }
                            }
                            onClick={(e) => {
                                e.stopPropagation();
                                // 정확한 비교를 위해 숫자로 변환
                                const tagId = Number(props.reference.tag_mappings[0].id);
                                const selectedTagsToNumber = selectedTags.map(Number);

                                if (selectedTagsToNumber.includes(tagId)) {
                                    // tagId가 포함되어 있다면 해당 태그를 제거
                                    const newTags = selectedTagsToNumber.filter((tag) => tag !== tagId);
                                    handleNavigate({ tags: newTags });
                                } else {
                                    // 포함되어 있지 않다면 tagId를 추가
                                    handleNavigate({ tags: [...selectedTagsToNumber, tagId] });
                                }
                            }}
                        >
                            <TagListText>{props.reference.tag_mappings[0].name}</TagListText>
                        </TagItem>
                    </Tooltip>
                    {props.reference.tag_mappings.length > 1 && (
                        <Dropdown
                            open={showTagBox}
                            onOpenChange={setShowTagBox}
                            placement="bottom-end"
                            offset={8}
                            anchor={
                                <MoreTag
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setShowTagBox((prev) => !prev);
                                    }}
                                >
                                    <TagListText>+{props.reference.tag_mappings.length - 1}</TagListText>
                                </MoreTag>
                            }
                        >
                            <MoreBox>
                                <MoreBoxHeader>
                                    <TagListTitle>태그 목록</TagListTitle>
                                    <Button
                                        {...BUTTON_STYLES.iconGhost}
                                        buttonSize={"20px"}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowTagBox(!showTagBox);
                                        }}
                                    >
                                        <Icon name={"x"} size={"8"} color={"var(--color-SubBlack)"} />
                                    </Button>
                                </MoreBoxHeader>
                                <MoreContentWrap>
                                    {props.reference.tag_mappings.map((tag, index) => (
                                        <Tooltip message={"필터 적용"} key={index + "tag"}>
                                            <TagItem
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const tagId = Number(tag.id);
                                                    // selectedTags 배열의 값들을 모두 숫자로 변환
                                                    const selectedTagsNumbers = selectedTags.map(Number);

                                                    if (selectedTagsNumbers.includes(tagId)) {
                                                        const newTags = selectedTagsNumbers.filter(
                                                            (selectedTag) => selectedTag !== tagId,
                                                        );
                                                        handleNavigate({ tags: newTags });
                                                    } else {
                                                        handleNavigate({ tags: [...selectedTagsNumbers, tagId] });
                                                    }
                                                }}
                                            >
                                                <TagListText>{tag.name}</TagListText>
                                            </TagItem>
                                        </Tooltip>
                                    ))}
                                </MoreContentWrap>
                            </MoreBox>
                        </Dropdown>
                    )}
                </TagItemWrap>
            ) : (
                <BlankBox>
                    <BlankText>연결된 태그가 없습니다.</BlankText>
                </BlankBox>
            )}
        </Container>
    );
}

export default ReferenceTagList;
